import React, { createContext, useContext, useState } from 'react'

interface Status {
  status_code: number
}

type StatusContextValue = {
  status: Status
  setStatus: React.Dispatch<React.SetStateAction<Status>>
}

const StatusContext = createContext<StatusContextValue>(
  {} as StatusContextValue
)

export function useStatus() {
  return useContext(StatusContext)
}

export function StatusProvider({ children }) {
  const initialStatus = {
    status_code: 200,
  }
  const [status, setStatus] = useState<Status>(initialStatus)
  const contextValue: StatusContextValue = {
    status,
    setStatus,
  }

  return (
    <StatusContext.Provider value={contextValue}>
      {children}
    </StatusContext.Provider>
  )
}
